import { AgxDivider, AgxRow, AgxTab } from '@urbanx/agx.ui-components2';
import { TeamPageTabs } from './TeamPageTabs';
import { useMemo } from 'react';
import { TeamPageTabOptions } from './TeamPageTabOptions';
import { useNavigate } from 'react-router-dom';
import { Pages } from 'constants/menu';
import useAgencyIdParam from 'hooks/useAgencyIdParam';

interface TeamPageHeaderProps {
  actionButtons?: React.ReactNode;
  selectedTab: TeamPageTabs;
  agencyId?: string;
}

const getPathForTab = (tab: string, agencyId: string) => {
  const basePath = `/${Pages.AGENCIES}/${agencyId}/${Pages.TEAMS}`;

  switch (tab) {
    case TeamPageTabs.AgencyUsers:
      return `${basePath}/${Pages.TEAMS_MEMBERS}`;
    case TeamPageTabs.ManageTeams:
      return `${basePath}/${Pages.TEAMS_MANAGE_TEAMS}`;
    case TeamPageTabs.UrbanXTeam:
      return `${basePath}/${Pages.TEAMS_URBANX_TEAM}`;
    default:
      return basePath;
  }
};

const TeamPageHeader = ({ actionButtons, selectedTab }: TeamPageHeaderProps) => {
  const agencyId = useAgencyIdParam();
  const navigate = useNavigate();

  const tabOptions = useMemo(() => {
    return TeamPageTabOptions.map((tab) => ({
      ...tab,
      selected: selectedTab === tab.id,
    }));
  }, [selectedTab]);

  return (
    <>
      <AgxRow fill justifyContent="space-between" alignItems="alignCenter">
        <AgxTab
          options={tabOptions}
          onChange={(tab) => {
            if (!agencyId || tab.id === selectedTab) return;
            navigate(getPathForTab(tab.id, agencyId));
          }}
        />
        {actionButtons}
      </AgxRow>
      <AgxDivider variant="horizontal" />
    </>
  );
};

export default TeamPageHeader;
